import { useEffect, useState } from 'react';
import { DropResult, OnDragEndResponder } from 'react-beautiful-dnd';
import { useParams } from 'react-router-dom';
import { useAuth } from '@screentone/addon-auth-wrapper';
import { cloneDeep } from 'lodash';

import { MobileIssueDtoArtifactFragment, useMobileIssueDtoByAllessehIdQuery } from 'data/generated/graphql';
import { reorderArray } from 'utils/array';

export const useIssueSections = () => {
  const { currentProperty } = useAuth();
  const { mobileIssueId } = useParams();

  const { data } = useMobileIssueDtoByAllessehIdQuery({
    id: mobileIssueId ?? '',
    publicationKey: currentProperty ?? '',
  });

  const mobileIssue = data?.mobileIssueDTOByAllessehId;

  const [originalIssue, setOriginalIssue] = useState<MobileIssueDtoArtifactFragment | null>(null);
  const [issue, setIssue] = useState<MobileIssueDtoArtifactFragment | null>(null);
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    if (!mobileIssue) return;
    setOriginalIssue(mobileIssue);
    setIssue(mobileIssue);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobileIssue]);

  const handleDragEnd: OnDragEndResponder = (result: DropResult) => {
    if (!issue || !result.destination) return;

    const { source, destination } = result;
    if (source.index === destination.index) return;

    setIssue(
      cloneDeep({
        ...issue,
        root: {
          ...issue.root,
          collection: reorderArray(issue.root.collection, source.index, destination.index)
        }
      })
    );
    setUpdated(true);
  };

  const hasData = !!issue;

  return {
    originalIssue,
    issue,
    setIssue,
    setOriginalIssue,
    updated,
    setUpdated,
    hasData,
    handleDragEnd,
  };
};
